import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import './Conversation.css';
import './Home.css';

const Home = () => {
    const navigate = useNavigate();

    return (
        <div>
            <h1>Welcome to KPOINT Catalyst (Nov - Dec)</h1>
            <p>Let's have an Innovation deep dive and get to know the latest updates in AI!</p>
            <button onClick={() => navigate('/Conversation')}>Talk to our Santa !</button>
        </div>
    );
};

export default Home;
